const KegiatanSearchCategories = [
  "pk",
  "nama_kegiatan",
  "kode_kegiatan",
  "file",
];

export default KegiatanSearchCategories;
